import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Typography } from '@mui/material';
import { ErrorComponentProps, useRouter } from '@tanstack/react-router';

interface UnexpectedErrorProps {
  onRetry: () => void;
}

function UnexpectedError({ onRetry }: UnexpectedErrorProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        textAlign: 'center',
      }}
      data-test-id="mwx-unexpected-error"
    >
      <ErrorOutlineIcon
        sx={{ fontSize: 100, color: 'text.secondary', mb: 4 }}
      />
      <Typography variant="h4" component="h1" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Try again. If the problem continues, contact Matterworks support.
      </Typography>
      <Button variant="contained" onClick={onRetry}>
        Try again
      </Button>
    </Box>
  );
}

export function RouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();

  const retry = () => {
    reset();
    void router.invalidate();
  };

  return <UnexpectedError onRetry={retry} />;
}

export function ApplicationError() {
  return <UnexpectedError onRetry={() => window.location.reload()} />;
}
